import {useRecoilValue} from "recoil";
import {spaceIdState} from "../state/spaceState";
import {useQueryClient} from "react-query";

const useTiming = () => {
  const queryClient = useQueryClient();
  const id = useRecoilValue(spaceIdState);

  return id && queryClient.getQueryData(['timings', id]);
}

export default useTiming;
